import firebase from "firebase/app";
import "firebase/storage";

/**
 * Documentos que Recnet pone a disposición del miembro.
 *
 * Los términos y condiciones son PDFs públicos en reconstruccion.net; el
 * brochure vive en Firebase Storage y su URL de descarga hay que pedirla
 * (lleva un token), no se puede componer a mano. Rutas tomadas de la app
 * (`recnet-24/app/screens/Profile/index.js`).
 */

const BROCHURE_STORAGE_PATH = "config/Brochure RecNet_251211_163737.pdf";

export const TERMINOS = [
  {
    titulo: "Términos y Condiciones",
    subtitulo: "Usuarios y Suscriptores",
    url: "https://www.reconstruccion.net/doc/suscriptores/tyc.pdf",
  },
  {
    titulo: "Términos y Condiciones",
    subtitulo: "Socios",
    url: "https://www.reconstruccion.net/doc/socios/tyc.pdf",
  },
];

/** URL de descarga del brochure, con su token de acceso. */
export function urlDelBrochure() {
  return firebase.storage().ref(BROCHURE_STORAGE_PATH).getDownloadURL();
}
